import { render, staticRenderFns } from "./StudentDocumentList.vue?vue&type=template&id=6771e406&scoped=true&"
import script from "./StudentDocumentList.vue?vue&type=script&lang=js&"
export * from "./StudentDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./StudentDocumentList.vue?vue&type=style&index=0&id=6771e406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6771e406",
  null
  
)

export default component.exports